import { render, staticRenderFns } from "./_TemplateElement.vue?vue&type=template&id=1a890be7&"
import script from "./_TemplateElement.vue?vue&type=script&lang=js&"
export * from "./_TemplateElement.vue?vue&type=script&lang=js&"
import style0 from "./_TemplateElement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports